// extracted by mini-css-extract-plugin
export default {"innerBlockGradient":"InnerBlockGradient_innerBlockGradient__CEi92","value":"InnerBlockGradient_value__vILvu"};